import script from "./PropertyCameras.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyCameras.vue?vue&type=script&setup=true&lang=js"

import "./PropertyCameras.vue?vue&type=style&index=0&id=65e129e6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e129e6"]])

export default __exports__